export default __webpack_public_path__ + "static/media/moneyNew.163b926c.jpg";